export enum CategoriesEnumList {
  CATEGORY = 'name',
  URL = 'url',
  LEVEL = 'level',
  VISIBILITY = 'visibility',
  NUMBER_PRODUCTS = 'numberProducts',
  ACTIONS = 'actions',
}
